/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import axios from "axios";
import dot from 'dot-object';
import { getToken } from 'datastake-daf/src/helpers/Token';
import { getAppHeader, getApiBaseUrl } from "../../../../services/BaseService";

export default function useAjaxModal({
  formsValue = {},
  call = null,
  isAjaxModal
}) {
  const [isFetching, setIsFetching] = useState(!!isAjaxModal);
  const [form, setForm] = useState(true);
  const [config, q, , d, opFilters, noDelete] = (call || '').split('::');
  const [disabledInputs, setDisabledInputs] = useState([]);
  const endpoint = `${getApiBaseUrl()}/linking/data`;

  useEffect(() => {
    if (isAjaxModal) {
      const query = q ? JSON.parse(q) : {};
      query.module = 'pme';
      if (formsValue && formsValue.id) {
        query.entityId = formsValue.id;
      }
      const dInputs = d ? JSON.parse(d) : [];
      const requestConfig = config ? JSON.parse(config) : {};
      setDisabledInputs(dInputs);
      axios.post(endpoint, {
        ...requestConfig,
        query
      }, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          ...getAppHeader(),
        },
      }).then(({ data }) => {
        if (data) {
          let optionFilters = [];
          try {
            optionFilters = JSON.parse(opFilters);
          } catch {

          }
          const form = data.form || {};
          if (optionFilters.length) {
            optionFilters.filter(f => f.path && (f.includes || f.set)).forEach(f => {
              if (f.set) {
                dot.set(f.path, f.set, form);
              } else {
                let options = dot.pick(f.path, form);
                if (options && Array.isArray(options)) {
                  options = options.filter(o => f.includes.includes(o.value));
                  dot.set(f.path, options, form);
                }
              }
            })
          }
          const dPaths = noDelete ? JSON.parse(noDelete) : [];
          dPaths.forEach(k => {
            if (typeof dot.pick(k, form) === 'object') {
              dot.set(`${k}.deleteDataOnHide`, false, form);
            }
          })
          setForm(form);
        }
        setIsFetching(false);
      }).catch((e) => {
        console.log(e);
        setIsFetching(false);
      });
    } else {
    }
  }, [])

  return {
    form,
    isFetching,
    setIsFetching,
    disabledInputs,
  };
}
